export const returnArrows = () => {
    var arr = ['ssa', 'psa', 'tsa', 'de_page_s1_arr', 'de_page_s2_arr',
    'de_page_s3_arr', 'de_page_s4_arr', 'de_btn_s1_arr', 'de_btn_s2_arr', 'de_btn_s3_arr',
    'de_btn_s4_arr', 'de_btn_s5_arr', 'de_btn_s6_arr', 'de_btn_s7_arr', 'de_btn_s8_arr', 'add-icn', 'tc_add-item-s'];
    for(var i = 0; i < arr.length; i++) {
        if(document.getElementById(arr[i])) {
        document.getElementById(arr[i]).style.transform = 'rotate(0deg)';
        }
    }
}